// RefundPolicy.js - Refund Policy page
// Public page — no auth required
// Route: /refund-policy
// Linked from footer and TermsOfService
// Last updated: May 2026

import React from 'react';

function RefundPolicy() {

  // Opens the browser print dialog for saving/printing this page
  const handlePrint = () => window.print();

  return (
    <div className="legal-page">
      <div className="legal-container">

        {/* Logo */}
        <a href="/" className="auth-logo">Evermark Memorial</a>

        <h1 className="legal-title">Refund Policy</h1>
        <p className="legal-effective">Last updated: May 2026</p>

        {/* ===== PRINT BUTTON ===== */}
        <div style={{ marginBottom: '24px' }}>
          <button
            onClick={handlePrint}
            style={{
              background: 'none',
              border: '1.5px solid #4a7c59',
              color: '#4a7c59',
              padding: '8px 20px',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500',
            }}
          >
            Print / Save as PDF
          </button>
        </div>

        {/* ===== FULL REFUND ===== */}
        <div className="legal-section">
          <h2>Full Refund</h2>
          <p>You are eligible for a full refund in the following situations:</p>
          <ul>
            <li>The job was never claimed by a caretaker within 5 business days of booking</li>
            <li>The cemetery was inaccessible due to closure or restriction at the time of the visit</li>
            <li>You cancel your booking before a caretaker has claimed the job</li>
            <li>The caretaker was unable to complete the service due to weather or site conditions beyond their control</li>
          </ul>
        </div>

        {/* ===== PARTIAL REFUND ===== */}
        <div className="legal-section">
          <h2>Partial Refund (50%)</h2>
          <p>A 50% partial refund may be issued in the following situation:</p>
          <ul>
            <li>An incorrect grave location was provided by the customer and the job could not be completed as a result</li>
          </ul>
          <p>
            We encourage all customers to double-check cemetery name, city, and any plot or section information
            before submitting a booking. Evermark Memorial and its caretakers are not responsible for visits
            to incorrect locations resulting from inaccurate information.
          </p>
        </div>

        {/* ===== NO REFUND ===== */}
        <div className="legal-section">
          <h2>No Refund</h2>
          <p>Refunds will not be issued in the following situations:</p>
          <ul>
            <li>The job was completed and before/after photos were submitted by the caretaker</li>
            <li>You cancel your booking after a caretaker has already claimed the job</li>
            <li>Decorations were removed by cemetery staff after the visit was completed — this is outside Evermark Memorial's control and does not qualify for a refund</li>
          </ul>
        </div>

        {/* ===== RESCHEDULE CREDIT ===== */}
        <div className="legal-section">
          <h2>Reschedule Credit</h2>
          <p>
            If you request a reschedule before a caretaker has claimed your job, you will receive a full
            credit to reschedule your visit at no additional charge. Reschedule credits do not expire.
          </p>
        </div>

        {/* ===== PROCESSING TIME ===== */}
        <div className="legal-section">
          <h2>Processing Time</h2>
          <p>
            Approved refunds are processed within <strong>5–10 business days</strong> back to the original
            payment method. Refund timing may vary depending on your card issuer or bank.
          </p>
          <p>
            To request a refund, contact us at{' '}
            <a href="mailto:support@evermarkmemorial.com" style={{ color: '#4a7c59' }}>
              support@evermarkmemorial.com
            </a>
            {' '}with your booking details and reason for the request.
          </p>
        </div>

        {/* ===== CONTACT ===== */}
        <div className="legal-section">
          <h2>Questions?</h2>
          <p>
            If you have questions about this policy or need to request a refund, please contact us through
            the <a href="/contact" style={{ color: '#4a7c59' }}>Contact page</a> or email{' '}
            <a href="mailto:support@evermarkmemorial.com" style={{ color: '#4a7c59' }}>
              support@evermarkmemorial.com
            </a>.
          </p>
        </div>

        {/* ===== LEGAL LINKS ===== */}
        <div className="contact-legal-links">
          <a href="/terms">Terms of Service</a>
          <a href="/privacy">Privacy Policy</a>
        </div>

      </div>
    </div>
  );
}

export default RefundPolicy;
